import React, { useMemo } from 'react';
import { getSmoothStepPath } from 'reactflow';

const SConnectorEdge = ({
  id,
  sourceX,
  sourceY,
  sourcePosition = 'right',
  targetX,
  targetY,
  targetPosition = 'left',
}) => {
  const [edgePath] = useMemo(
    () =>
      getSmoothStepPath({
        sourceX,
        sourceY,
        sourcePosition,
        targetX,
        targetY,
        targetPosition,
        borderRadius: 80,
      }),
    [sourceX, sourceY, sourcePosition, targetX, targetY, targetPosition]
  );

  const markerId = `arrow-${id}`;

  return (
    <g>
      <defs>
        <marker
          id={markerId}
          viewBox="0 0 10 10"
          refX="10"
          refY="5"
          markerWidth="10"
          markerHeight="10"
          orient="auto"
        >
          <path d="M0,0 L10,5 L0,10 L3,5 Z" fill="#EE2B2A" />
        </marker>
      </defs>
      <path
        d={edgePath}
        fill="none"
        stroke="#EE2B2A"
        strokeWidth="3"
        markerEnd={`url(#${markerId})`}
      />
    </g>
  );
};

export default SConnectorEdge;
